<!--
* @FileDescription: 网络相关工具
* @Author: Rocky
* @Date: 2020-08-28
* @LastEditors: Rocky
* @LastEditTime: 2020-08-28
-->

<script>
// import cookie from '@/components/toolkits/cookie.vue'
import axios from 'axios'

var envUrl = ''
if (process.env.NODE_ENV === 'development') {
  envUrl = '/api/cms/handler/' // 开发环境
} else {
  envUrl = 'https://api.xinlu39.com/cms/handler/' // 打包时
}
const SERVER_URL = envUrl

/**
 * 网络请求（纯净版）
 * 一般用于登录前的请求，自由配置 data，不附加任何增修，返回也同样，直接返回服务器值
 */
function request (settings) {
  var args = {
    rootUrl: settings.rootUrl || SERVER_URL,
    url: settings.url || '',
    method: settings.method || 'GET',
    data: settings.data || null,
    contentType: settings.contentType || 'application/json',
    success: settings.success || function () {},
    error: settings.error || function () {},
    complete: settings.complete || function () {}
  }
  // 处理请求链接
  var url = ''
  url = (args.method === 'GET') ? getFormat(args.url, args.data) : args.url
  url = args.rootUrl + url
  axios({
    method: args.method,
    url: url,
    data: args.data,
    headers: {'content-type': args.contentType}
  }).then(function (res) {
    args.success(res)
  }).catch(function (error) {
    // 连接错误
    var errMsg = ['本地连接出错 / 获取不到数据']
    errMsg.push(error)
    args.error(errMsg)
  })
}

/** * 形成 get 请求字符串
 * @param {string} url 访问的地址
 * @param {dict} dict 需要组合的字典
 */
function getFormat (url, dict) {
  var getStr = ''
  var newUrl = url
  for (var key in dict) {
    getStr += (getStr === '') ? '' : '&'
    getStr += key + '=' + dict[key]
  }
  newUrl += '?' + getStr
  return newUrl
}

export default {
  request
}
</script>



// WEBPACK FOOTER //
// src/components/toolkits/server.vue